// Shared animation timing constants for Streaker features.
// Both StreakerEffect (sim) and StreakerInteractiveModal (interactive) use
// the same confetti FX so the two modes feel like the same product.
export const CONFETTI_DURATION_MS = 2000;
export const CONFETTI_COUNT = 26;  // 👏 clap particles on a successful escape
export const THUMBS_COUNT = 18;    // 👎 thumb particles on a catch
